import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { host_url } from '../../../App'; // Import host_url
import { Link } from 'react-router-dom'; // Import Link
import '../../../styles/CiTable.css';
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente
import { MdKeyboardArrowDown } from "react-icons/md";

function ZuteilungZelt() {
  const [einheiten, setEinheiten] = useState([]);
  const [zelte, setZelte] = useState([]);
  const [zuteilungen, setZuteilungen] = useState([]);
  const [selectedEinheit, setSelectedEinheit] = useState('');
  const [selectedZelt, setSelectedZelt] = useState('');
  const [selectedZeltName, setSelectedZeltName] = useState('');

  useEffect(() => {
    const einheitIDCookie = Cookies.get('selectedEinheit');
    const zeltIDCookie = Cookies.get('selectedZelt');
    const zeltNameCookie = Cookies.get('selected_zelt');
    if (einheitIDCookie) setSelectedEinheit(einheitIDCookie);
    if (zeltIDCookie) setSelectedZelt(zeltIDCookie);
    if (zeltNameCookie) setSelectedZeltName(zeltNameCookie);
  }, []);

  useEffect(() => {
    fetch(`${host_url}/einheiten`)
      .then(response => response.json())
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        list.sort((a, b) => a.Name.localeCompare(b.Name));
        setEinheiten(list);
      })
      .catch(error => console.error('Error fetching einheiten:', error));
  }, []);

  useEffect(() => {
    fetch(`${host_url}/zelte`)
      .then(response => response.json())
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        list.sort((a, b) => a.Zeltname.localeCompare(b.Zeltname));
        setZelte(list);
      })
      .catch(error => console.error('Error fetching zelte:', error));
  }, []);

  useEffect(() => {
    if (selectedEinheit || selectedZelt) {
      setZuteilungen([]); // Reset zuteilungen before fetching new data
      const query = new URLSearchParams();
      if (selectedEinheit) query.append('einheitId', selectedEinheit);
      if (selectedZelt) query.append('zeltId', selectedZelt);

      fetch(`${host_url}/zuteilungen?${query.toString()}`)
        .then(response => response.json())
        .then(data => setZuteilungen(Array.isArray(data) ? data : []))
        .catch(error => console.error('Error fetching zuteilungen:', error));
    } else {
      setZuteilungen([]);
    }
  }, [selectedEinheit, selectedZelt]);

  const handleEinheitChange = (e) => {
    setSelectedEinheit(e.target.value);
    Cookies.set('selectedEinheit', e.target.value);
  };

  const handleZeltChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setSelectedZelt(e.target.value);
    setSelectedZeltName(selectedOption.text);
    Cookies.set('selectedZelt', e.target.value);
    Cookies.set('selected_zelt', selectedOption.text);
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/jobportal" />
        <h1>Zuteilung der Jobs</h1>
      </div>
      <div className="zuteilung-zelt-form dropdown-form">
        <label>
          Einheit
          <div className={`dropdown-wrapper ${selectedEinheit ? 'filled' : ''}`}>
            <select id="einheit" name="einheit" value={selectedEinheit} onChange={handleEinheitChange}>
              <option value="">Wähle eine Einheit</option>
              {Array.isArray(einheiten) && einheiten.map(einheit => (
                <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>
              ))}
            </select>
            <MdKeyboardArrowDown className="dropdown-chevron" />
          </div>
        </label>
        <label>
          Zelt
          <div className={`dropdown-wrapper ${selectedZelt ? 'filled' : ''}`}>
            <select id="zelt" name="zelt" value={selectedZelt} onChange={handleZeltChange}>
              <option value="">{selectedZeltName || 'Wähle ein Zelt'}</option>
              {Array.isArray(zelte) && zelte.map(zelt => (
                <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>
              ))}
            </select>
            <MdKeyboardArrowDown className="dropdown-chevron" />
          </div>
        </label>
      </div>
      {!selectedEinheit && !selectedZelt ? (
        <p>Wähle eine Einheit oder ein Zelt, um die Zuteilungen zu sehen.</p>
      ) : zuteilungen.length === 0 ? (
        <p>Keine Zuteilungen gefunden.</p>
      ) : (
        <div className="ci-table-wrapper">
        <table className="ci-table">
          <thead>
            <tr>
              <th>Kind</th>
              <th>Job</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(zuteilungen) && zuteilungen.map(zuteilung => (
              <tr key={`${zuteilung.KindID}-${zuteilung.JobID || zuteilung.ZeltID}`}>
                <td>{zuteilung.KindName}</td>
                <td>
                  <Link to={`/stadtplan?jobId=${zuteilung.JobID}`}>
                    {zuteilung.JobName}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}

export default ZuteilungZelt;
